import Service from "../AuthService";
import {domain} from "@/util/Constants";

const Eventform = {
    createCaseid(id) {
        return Service.post('/cases?type=' +id)
        },
    getCase(id) {
        return Service.get('/cases?type=' +id)
    },
    refer(id, data) {
        return Service.post('/refer/' +id, data)
    },
    getNewReferCase(id) {
        return Service.get('/new-refer/'+ id)
    },
    getAppearances(id) {
        return Service.get('/appearances/' + id)
    },
    getCaseID(id, receiveCase,isRefer) {
        return Service.get('/cases/'+ id + '?received=' + receiveCase + '&isRefer=' + isRefer )
    },
    getSearch(data) {
        return Service.get('/cases?startDate=' + data.startDate + '&endDate=' + data.endDate + '&searchText=' + data.searchText + '&type=' + data.type);
    },
    getExport(data){
        window.open(`${domain}/cases/export?startDate=${data.startDate}&endDate=${data.endDate}&searchText=${data.searchText}&hospital_code=${data.hospital_code}`)
    },
    getExportSubmission(data){
        window.open(`${domain}/cases/export/pdf?case_id=${data.id}&form_type=Submission&picture=${data.picture}`)
    },
    getExportRequisition(data){
        window.open(`${domain}/cases/export/pdf?case_id=${data.id}&form_type=Requisition`)
    },
    getExportRefer(data){
        window.open(`${domain}/cases/export/pdf?case_id=${data.id}&form_type=Refer`)
    },
    putCaseform(id,data) {
        return Service.put('/cases/'+ id,data)
    },
    getInjuryCaseForm(id) {
        return Service.get('/cases/injury/'+ id )
    },
    postInjuryCaseForm(id,data) {
        return Service.post('/cases/injury/'+ id ,data)
    },
    putAppearances(id,data) {
        return Service.put('/appearances/'+ id,data)
    },
    getTransformationID(id) {
        return Service.get('/transformations/'+ id)
    },
    putTransformation(id,data) {
        return Service.put('/transformations/'+ id,data)
    },
    addEvidence(id,data) {
        console.log("datassss",data)
        return Service.put('/evidences/'+ id,data)
    },
    getEvidence(id,data) {
        return Service.get('/evidences/'+ id)
    },
    deleteEvidence(data) {
        // console.log(data)
        return Service.post(`/evidences/${data.id}?no=${data.no}`)
    },

    saveImage(id,data) {
        return Service.post('/save-image/'+ id, data)
    },
    dashboard(){
        return Service.get('/cases/dashboard/')
    },
    uploadImg(data){
        return Service.post('/uploadImg/'+ data.id, data)
    },
    getCaseImg(data){
        return Service.get(`/caseImg/${data.id}?case_id=${data.case_id}`)
    },
    getCardImg(data){
        return Service.get(`/cardImg/${data.id}?case_id=${data.case_id}`)
    },
    getDeadBodyImg(data){
        return Service.get(`/deadBodyImg/${data.id}?case_id=${data.case_id}`)
    },
    deleteCaseImg(data){
        return Service.post('/caseImg/'+ data.id, data )
    },
    deleteCardImg(data){
        return Service.post('/cardImg/'+ data.id, data )
    },
    deleteDeadBodyImg(data){
        return Service.post('/deadBodyImg/'+ data.id, data )
    },
    uploadCardImg(data){
        return Service.post('/cases/uploadCardImage/'+ data.id, data )
    },
    getImgCard(data){
        return Service.get(`/cases/getCardImage/${data.id}?name=${data.name}`)
    },
    sendEmail(data){
        return Service.post('/cases/sendEmail/'+data.id,data)
    },
    changeStatus(data){
        return Service.post('/cases/changeStatus/'+data.id,data)
    },
    saveLog(data){
        return Service.post('/cases/saveLog/'+data.id,data)
    },

};


export default Eventform;
